/**
 * styles.ts
 *
 * Author: Maurice T. Meyer
 * E-Mail: maurice@lavireo.com
 *
 * (c) Laviréo. All rights reserved.
 *
 * This document is the property of Laviréo.
 * It is considered confidential and proprietary.
 *
 * This document may not be reproduced or transmitted in any form,
 * in whole or in part, without the express written permission of
 * Laviréo.
 */

import { css } from '@emotion/react';

export const styles = {
  container: css({
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: '4px',
  }),

  label: css({
    fontSize: '14px',
    fontWeight: '500',
    lineHeight: '20px',
    color: 'rgb(132, 132, 140)',
    margin: 0,
    border: 0,
    padding: 0
  }),

  info: css({
    width: '14px',
    height: '14px',
    cursor: 'pointer',
    borderRadius: '8px',
    border: '1px solid rgb(132, 132, 140)',
    margin: 0,
    padding: 0,
    outline: 'none',
    appearance: 'none',
    fontFamily: 'inherit',
    background: 'transparent'
  })
}